"use strict";

import Vue from "vue";
import axios from "axios";
import store from "../store";
import router from "../router";
// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

const token = window.$cookies.get("token-sudthd");
if (token) {
	axios.defaults.headers.common["Authorization"] = "Bearer " + token;
}

let config = {
	// baseURL: process.env.baseURL || process.env.apiUrl || ""
	// timeout: 60 * 1000, // Timeout
	// withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
	function (config) {
		// Do something before request is sent
		window.Event.$emit('before-request');

		return config;
	},
	function (error) {
		// Do something with request error
		window.Event.$emit('request-error');
		return Promise.reject(error);
	}
);

// Add a response interceptor
_axios.interceptors.response.use(
	function (response) {

		//gestion des erreurs d'insertion
		if (response.data.success === false && (response.config.method == "post" || response.config.method == "put")) {
			let str = "";
			if (response.data.data.length > 0) {
				response.data.data.forEach(element => {
					if (element.messageTemplate) {
						str += element.messageTemplate + "</br>";
					}
				});
			}

			if (str != "") {
				Vue.prototype.$awn.alert(
					str
				);
			} else {
				Vue.prototype.$awn.alert(
					response.data.message.toString()
				);
			}

		}

		window.Event.$emit('after-response');
		// Do something with response data
		return response;
	},
	function (error) {
		// Do something with response error
		window.Event.$emit('request-error');

		if (error.response.status === 500) {
			Vue.prototype.$awn.alert("Erreur interne du serveur", {
				position: "bottom-right",
				timeout: 3000
			});
			return Promise.reject(error);
		} else if (error.response.status === 404) {
			Vue.prototype.$awn.alert("Cette route n'existe pas sur l'api", {
				position: "bottom-right",
				timeout: 3000
			});
			return Promise.reject(error);
		} else if (error.response.status === 403) {
			Vue.prototype.$awn.alert(error.response.data.detail, {
				position: "bottom-right",
				timeout: 3000
			});
			return Promise.reject(error);
		} else if (error.response.status === 401 && router.currentRoute.name == 'Login' && router.currentRoute.name == 'Password') {


		} else if (error.response.status === 401 && router.currentRoute.name != 'Login' && router.currentRoute.name != 'Password') {
			Vue.prototype.$awn.warning("Session expirée", {
				position: "bottom-right",
				timeout: 3000
			});
			store.dispatch(
				"Authentification/logout",
				store.getters["Authentification/userConnected"]
			);
			return Promise.reject(error);
		} else if (error.response.status === 401 && router.currentRoute.name == 'Password') {
			Vue.prototype.$awn.alert("Lien plus valide", {
				position: "bottom-right",
				timeout: 3000
			});
			return Promise.reject(error);
		} else if (error.response.status === 401 && router.currentRoute.name == 'Login' && error.response.data.message == "Identifiant ou Mot de Passe erroné") {


			Vue.prototype.$awn.alert(error.response.data.message, {
				position: "bottom-right",
				timeout: 3000
			});
			return Promise.reject(error);
		} else {
			return Promise.reject(error);
		}

	}
);

Plugin.install = function (Vue) {
	Vue.axios = _axios;
	window.axios = _axios;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return _axios;
			}
		},
		$axios: {
			get() {
				return _axios;
			}
		}
	});
};

Vue.use(Plugin);

export default Plugin;